import React from 'react';
import Banner from './Banner';
import UserLoginType from '../../../views/login/UserLoginType';
import Whatsapp from '../../../views/login/Whatsapp.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import ModalVideo from 'react-modal-video';
import vishwanathanHome from '../../../images/icons/vishwanathan_home_banner.png';
/*
* This class is merely an extension of the previous banner
*
*/
export default class Banner2 extends Banner{
	
	homeforweb(){

		  return (
			<div className="slider-inner b-web-comp" style={{padding:'50px 0px 25px'}}>
			<div  className="col-12 b-right" style={{display:'none'}}>
				<div className="r-banner">
					<img src="../img/banner1.png" alt="" onClick={this.openModal}/>
					<a data-ga="Home  - Hey Parent Video" className="popup-modal" onClick={this.openModal}><span className="play-btn"></span></a>
				</div>
			</div>
			<div className="row  slider-inner-shadow">
				<div className="col-lg-12 col-md-12 col-sm-12">
					<h1 className="heading-one" style={{textAlign:'center',marginBottom:'20px'}}>
						<span className="txtcnt first-line" style={{fontSize:'32px'}}>{this.rb("banner.heading.2")}</span> 
						<span className="txtcnt furtxt" style={{fontSize:'32px'}}>{this.rb("banner.subheading.2")}</span>
						<span className="txtcnt furtxt" style={{fontSize:'32px'}}>{this.rb("banner.subheading1.2")}</span>
					</h1>
				
				
						
				{(() => {

					if(this.props.PLPloggedIn){ 
						if(this.isFreeTrialAllowed()){
								const styles={
								display: 'flex',
							    justifyContent: 'center',
							    flexFlow: 'column'
							}
							return(
								<div className="col-3 nopadding mx-auto joingrp" style={styles}>
									<a href="#" align="center" data-ga="Home - Best Math Teacher - Free Trial" className="r-btn" onClick={this.props.startFreeTrial}>Start your Free Trial</a>
									<Whatsapp align="center" maxWidth="100%">/</Whatsapp>
								</div>
							);
						}else{
							return (<span></span>);
						}						
					}else{
						const styles={
							margin:'0 auto'
						}

						return(
								
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType styles={styles} showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"}/>
									<Whatsapp align="center" maxWidth="100%">/</Whatsapp>
								</div>
								
						);
					}
				})()}	
			
				<div className="clearfix"></div>
				<div>
					<ul className="nottxt">
						{/* <li>{this.rb("banner.points1")}</li>
						<li>{this.rb("banner.points2")}</li>
						<li>{this.rb("banner.points3")}</li> 
						<li>{this.rb("banner.points4")}<span>{this.rb("banner.price")}</span></li>*/}
					</ul>				
				</div> 
			</div>	
			{/* <div className="col-lg-5 col-md-5 col-sm-12 vishwanathanBanner">
				<img src={vishwanathanHome} alt="Vishwanathan image in Homepage" />
			</div> */}
			</div> 
			</div>
		  )
	  }


	  homeformobile(){
		return (
			<div className="comp-inner">
			
			<div className="row text-center b-comp">
			<div className="col-lg-7 col-md-7 col-sm-12">
				<div>
				<div><span className="txtcnt">{this.rb("banner.heading.2")}</span></div> 
				<div>
					<span className="txtcnt furtxt">{this.rb("banner.subheading.2")}</span>
					<span className="txtcnt furtxt">{this.rb("banner.subheading1.2")}</span>
				</div>
				</div>


				{(() => {
					if(this.props.PLPloggedIn){ 
						if(this.isFreeTrialAllowed()){
							return(
							<div className="paddtri">
								<a href="#" data-ga="Home - Best Math Teacher - Free Trial" className="r-btn text-center" onClick={this.props.startFreeTrial}>Start your Free Trial</a>
								<Whatsapp align="center" background={"#30BDBD"} maxWidth="100%">/</Whatsapp>
							</div>
						);
						}else{
							return (<span></span>);
						}						
					}else{
						return(
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"}/>
									<Whatsapp align="center" background={"#30BDBD"} maxWidth="100%">/</Whatsapp>
								</div>
						);
					}
				})()}

				<div className="clearfix"></div>
				<div>
				<ul className="nottxt">
					{/* <li>{this.rb("banner.points1")}</li>
					<li>{this.rb("banner.points2")}</li>
					<li>{this.rb("banner.points3")}</li> 
					<li>{this.rb("banner.points4")}<span>{this.rb("banner.price")}</span></li>*/}
				</ul>
				
			</div> 
			</div>
			{/* <div className="col-lg-5 col-md-5 col-sm-12 vishwanathanBanner">
				<img src={vishwanathanHome} alt="Vishwanathan image in Homepage" />
			</div> */}	
			</div> 

			<div  className="col-12">
				<div className="r-banner">
					{/* <img src="../img/banner1.png" alt="" onClick={this.openModal}/>
					<a data-ga="Home  - Hey Parent Video" className="popup-modal" onClick={this.openModal}><span className="play-btn"></span></a> */}
				</div>
			</div>

			</div>
		  ) 
	  }

	  homecomponent(){
		let addCls = this.props.addCls || '';
		if(this.isMobile() || this.isTab()){
			return (
				<section className={"h-mob-banner "+addCls}>  
					<div className="swiper-container home-banner"> 
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/} 
							<div className="swiper-slide"> 
								<div className="container">
									{this.homeformobile()}
								</div>
								</div>
							
						{/*</Swiper>*/} 
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({isOpen: false})} />  
				</section>
			)
			
		}else{
			return(
				<section className={"h-banner "+addCls}>  
					<div className="swiper-container home-bannerweb"> 
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/} 
							<div className="swiper-slide"> 
								<div className="container">
									{this.homeforweb()}
								</div>
								</div>
							
						{/*</Swiper>*/} 
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({isOpen: false})} />  
				</section>

			)
		}
	}

}


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Banner2.js